import React from "react";
import './style.css';
import wordSets from "../../../config/loaderConfig";

const Loader_dynamic = ({ type = "web_vul", cloud = null }) => {
  let words = [];

  if (cloud) {
    words = (wordSets[cloud] && wordSets[cloud][type]) || ["No word set found"];
  } else {
    words = wordSets[type] || ["No word set found"];
  }
  let heading = `Scanning for ${
    type === "web_vul" || type === "network_vul"
      ? "Vulnerabilities"
      : type === "misconfig"
      ? "Misconfigurations"
      : "Unknown"
  }`;

  return (
    <div className="loader-4">
      <div className="card border-0" style={{ width: "400px" }}>
        <div className="loader">
          <p
            className="fw-semibold text-end mt-3 me-2"
            style={{ width: 120, lineHeight: "1rem", fontSize: "0.8rem" }}
          >
            {heading}
          </p>
          <div className="words">
            {words.map((word, idx) => (
              <span className="word" key={idx}>
                {word}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader_dynamic;